import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Container, Paper, TextField, Button, Typography, Alert, Box } from '@mui/material'
import { useAuth } from '../contexts/AuthContext'
import { apiClient } from '../services/api'

export default function ChangePasswordPage() {
    const navigate = useNavigate()
    const { user } = useAuth()
    const [newPassword, setNewPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const [error, setError] = useState<string | null>(null)
    const [success, setSuccess] = useState(false)
    const [loading, setLoading] = useState(false)

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault()
        setError(null)
        setSuccess(false)

        if (newPassword !== confirmPassword) {
            setError('Passwords do not match')
            return
        }

        if (!user) {
            setError('You must be logged in to change your password')
            return
        }

        setLoading(true)

        try {
            const response = await apiClient.changePassword(user.id, newPassword)
            if (response.success) {
                setSuccess(true)
                setNewPassword('')
                setConfirmPassword('')
                setTimeout(() => {
                    navigate('/')
                }, 2000)
            } else {
                setError('Failed to change password')
            }
        } catch (err: any) {
            setError(err.response?.data?.error || 'Failed to change password')
        } finally {
            setLoading(false)
        }
    }

    return (
        <Container maxWidth="sm">
            <Box sx={{ mt: 8 }}>
                <Paper sx={{ p: 4 }}>
                    <Typography variant="h4" component="h1" gutterBottom align="center">
                        Change Password
                    </Typography>
                    {error && (
                        <Alert severity="error" sx={{ mb: 2 }}>
                            {error}
                        </Alert>
                    )}
                    {success && (
                        <Alert severity="success" sx={{ mb: 2 }}>
                            Password changed successfully! Redirecting...
                        </Alert>
                    )}
                    <form onSubmit={handleSubmit}>
                        <TextField
                            fullWidth
                            label="New Password"
                            type="password"
                            value={newPassword}
                            onChange={e => setNewPassword(e.target.value)}
                            margin="normal"
                            required
                            autoFocus
                        />
                        <TextField
                            fullWidth
                            label="Confirm New Password"
                            type="password"
                            value={confirmPassword}
                            onChange={e => setConfirmPassword(e.target.value)}
                            margin="normal"
                            required
                        />
                        <Button type="submit" fullWidth variant="contained" sx={{ mt: 3 }} disabled={loading}>
                            {loading ? 'Changing Password...' : 'Change Password'}
                        </Button>
                        <Button fullWidth variant="outlined" sx={{ mt: 2 }} onClick={() => navigate('/')}>
                            Cancel
                        </Button>
                    </form>
                </Paper>
            </Box>
        </Container>
    )
}
